<script setup lang="ts">
/**
 * Hairline between the blocks of an action column (common tools → functions →
 * notes). A real `separator` for assistive technology. `spaced` adds the
 * vertical breathing room the top-level blocks use; without it the line sits
 * flush, as between rows of one list.
 */
withDefaults(defineProps<{ spaced?: boolean }>(), { spaced: false });
</script>

<template>
  <hr class="nx-action-separator" :class="{ 'is-spaced': spaced }" />
</template>

<style scoped>
.nx-action-separator {
  width: 100%;
  height: 0;
  margin: 0;
  border: 0;
  border-block-start: var(--nxt-hairline) solid var(--nxt-border);
  background: none;
}
.nx-action-separator.is-spaced {
  margin-block: var(--nxt-space-sm);
}
</style>
